"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = verifyCsrfToken;
function verifyCsrfToken(req, res, next) {
    const clientCsrf = req.cookies._csrf;
    const serverCsrf = req.session.csrfToken;
    if (serverCsrf && clientCsrf !== serverCsrf) {
        res.sendStatus(403);
    }
    else {
        next();
    }
}
